import { makeObservable, observable, runInAction, action, computed, toJS } from 'mobx';
import { ExpenseService } from '../services/expenseServices';
import { UtilsServices } from '../services/utilsServices';

import i18n from 'i18next';
import { toast } from "react-toastify";
import { lpad } from "../../utils";
import moment from 'moment';

export default class BilledExpensesFormStore {
    rootStore;

    billedExpense = {
        items: []
    };

    criteria = {};

    isLoading = true;

    constructor(rootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            isLoading: observable,
            billedExpense: observable,
            getBilledExpense: action,
            getTotal: computed,
            add: action,
            remove: action,
            save: action,
            setAttachment: action,
            updateExchangeRate: action,
            isSelectedCurrencyIsTheSameAsTheExpense: action
        });
    }

    updateExchangeRate = async (expense) => {

        var d = moment(expense.date);
        var month = d.month() + 1;
        var year = d.year();

        if (!expense.currencyId) {
            expense.exchangeRate = null;
            return;
        }

        runInAction(async () => {
            expense.rateLoading = true;
        });

        await UtilsServices.getExchangeRate(year, month, expense.currencyId, this.billedExpense?.currency?.shortName).then(rates => {

            var rate = rates.find(x =>
                x.to.code.toUpperCase() == this.billedExpense?.currency?.shortName?.toUpperCase()
                && x.from.id == expense.currencyId && x.month == month && x.year == year)?.rate ?? '';

            runInAction(async () => {
                expense.exchangeRate = rate;
            });

        });

        runInAction(async () => {
            expense.rateLoading = false;
        });

    }

    setAttachment = (expense, attachment) => {
        runInAction(() => {
            expense.attachmentId = attachment?.id ?? null;
            expense.attachment = attachment;
        })
    }

    save = async (event) => {
        try {
            runInAction(() => {
                this.isLoading = true;
            });

            event.preventDefault();
            const form = event.currentTarget;

            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            }
            else {
                var data = await ExpenseService.saveBilledExpense(this.billedExpense);

                runInAction(() => {
                    toast.success(i18n.t('billedExpenseSavedSuccessfully'));
                    this.getBilledExpense(this.criteria.year, this.criteria.month, this.criteria.activityId);
                });
            }
        } catch {
            runInAction(() => {
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    add = () => {
        runInAction(() => {
            this.billedExpense.items.push({ date: `${this.criteria.year}-${lpad(this.criteria.month, 2)}-01` });
        });
    }

    remove = (i) => {
        runInAction(() => {
            this.billedExpense.items.splice(i, 1);
        });
    }

    getBilledExpense = async (year, month, activityId) => {
        try {

            runInAction(() => {
                this.isLoading = true;
                this.criteria.month = month;
                this.criteria.year = year;
                this.criteria.activityId = activityId;
            });

            var data = await ExpenseService.getBilledExpense(this.criteria);

            runInAction(() => {
                this.billedExpense = data;
            });
        } catch {
            runInAction(() => {
                this.billedExpense = {
                    items: []
                };
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    getConvertedAmount = (expense) => expense.amountInLocalCurrency && expense.exchangeRate ? this.roundAwayFromZero((expense.exchangeRate * expense.amountInLocalCurrency), 2) : "";

    sumArray = (a) => a?.reduce((total, quantity) => total + (Number(quantity) || 0), 0);

    isLocalCurrency = (currencies, id) => currencies?.find(x => x.id == id)?.code?.toUpperCase() === "CHF";

    isSelectedCurrencyIsTheSameAsTheExpense = (currencies, expenseCurrencyId, currentCurrencyCode) => { return currencies?.find(x => x.id == expenseCurrencyId)?.code?.toUpperCase() == currentCurrencyCode; }

    get getTotal() {
        return this.sumArray(this.billedExpense.items.map((item) => this.getConvertedAmount(item)));
    }

    roundAwayFromZero = (number, decimalPlaces) => {
        if (decimalPlaces === undefined) {
            const sign = Math.sign(number);
            const absNum = Math.abs(number);
            const roundedAbs = Math.round(absNum);

            if (absNum - Math.floor(absNum) === 0.5) {
                return sign * (Math.floor(absNum) + 1);
            } else {
                return sign * roundedAbs;
            }

        } else {
            const factor = Math.pow(10, decimalPlaces);
            const scaledNumber = number * factor;
            const sign = Math.sign(scaledNumber);
            const absScaledNum = Math.abs(scaledNumber);
            const roundedAbsScaled = Math.round(absScaledNum);

            if (absScaledNum - Math.floor(absScaledNum) === 0.5) {
                return (sign * (Math.floor(absScaledNum) + 1)) / factor;
            } else {
                return (sign * roundedAbsScaled) / factor;
            }
        }
    }
}